module.exports = __webpack_public_path__ + "static/img/13.90d113d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/features_admin_activity/13.png
// module id = bX9P
// module chunks = 0